import { IPublicClientApplication } from '@azure/msal-browser';
import { ApplicationStateService } from '@core/services/application-state.service';
import { FeatureFlagService } from '@core/feature-toggle/feature-flag.service';
import { ThemeService } from '@shared/common-ui/lib/services/theme.service';

export function initializeApplication(
  featureFlagsInitService: FeatureFlagService,
  applicationStateService: ApplicationStateService,
  themeService: ThemeService,
  msalInstance: IPublicClientApplication,
) {
  return async () => {
    await msalInstance.initialize();
    await featureFlagsInitService.initialize();
    await applicationStateService.initializeApplication();
    await themeService.InitThemeService();
    return true;
  };
}
